import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { Warning, Lock, LockOpen } from "@mui/icons-material";

const LockToggleConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  isCurrentlyLocked,
  loading,
}) => {
  const willBeLocked = !isCurrentlyLocked;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          {willBeLocked ? (
            <LockOpen sx={{ color: "#4caf50", fontSize: 28 }} />
          ) : (
            <Lock sx={{ color: "#ff9800", fontSize: 28 }} />
          )}
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {willBeLocked
              ? "Enable Editing Mode?"
              : "Disable Editing Mode?"}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box display="flex" alignItems="flex-start" gap={2} mb={2}>
          <Warning sx={{ color: "#ff9800", mt: 0.5 }} />
          <Box>
            <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
              {willBeLocked
                ? "This will enable editing for:"
                : "This will disable editing for:"}
            </Typography>
            <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 1 }}>
              <li>Bet Limits configuration</li>
              <li>Market Margins and RTP settings</li>
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {willBeLocked
                ? "You'll be able to modify betting limits and margin settings."
                : "The sections will become read-only and changes won't be possible."}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            p: 2,
            backgroundColor: willBeLocked ? "#e8f5e8" : "#fff3e0",
            borderRadius: 2,
            border: willBeLocked ? "1px solid #4caf50" : "1px solid #ff9800",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            ⚠️ This change will be saved immediately and cannot be undone without
            proper permissions.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : willBeLocked ? (
              <LockOpen />
            ) : (
              <Lock />
            )
          }
          sx={{
            backgroundColor: willBeLocked ? "#4caf50" : "#ff9800",
            minWidth: 140,
            "&:hover": {
              backgroundColor: willBeLocked ? "#45a049" : "#f57c00",
            },
          }}
        >
          {loading
            ? "Saving..."
            : willBeLocked
            ? "Enable Editing"
            : "Disable Editing"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LockToggleConfirmDialog;